<template>
  <div>
    <div class="tab-title">我的资料</div>
    <div class="profile-tab-container">
      <el-form
        :model="userProfileForm"
        :rules="rules"
        ref="userProfileForm"
        label-width="100px"
        class="user-profile-form"
      >
        <el-form-item prop="headImgUrl" class="head-image-wrap">
          <img
            class="user-profile-avatar"
            src="../../assets/image/cl_user_avatar.png"
            v-real-img="userProfileForm.thumbHeadImg"
          />
          <p class="modify-avatar-wrap">
            <el-button class="modify-avatar-btn" @click="modifyAvatar"
              >更换头像</el-button
            >
          </p>
          <el-input
            type="hidden"
            v-model="userProfileForm.headImgUrl"
          ></el-input>
          <el-input
            type="hidden"
            v-model="userProfileForm.thumbHeadImg"
          ></el-input>
        </el-form-item>
        <el-form-item prop="thumbHeadImg" style="display: none">
          <el-input
            type="hidden"
            v-model="userProfileForm.thumbHeadImg"
          ></el-input>
        </el-form-item>
        <el-form-item label="网名" prop="name" class="profile-form-item">
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.name"
              placeholder="输入网名"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="姓名" prop="realName" class="profile-form-item">
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.realName"
              :disabled="certified"
              placeholder="输入姓名"
            ></el-input>
          </div>
          <span class="certified" v-show="certified">已认证</span>
        </el-form-item>
        <el-form-item label="性别" prop="sex" class="profile-form-item">
          <div class="profile-item-content">
            <el-radio-group v-model="userProfileForm.sex" :disabled="certified">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="生日" prop="birthday" class="profile-form-item">
          <div class="profile-item-content">
            <el-date-picker
              class="profile-date-select"
              :disabled="certified"
              v-model="userProfileForm.birthday"
              value-format="yyyy-MM-dd"
              placeholder="选择生日"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="乳名" prop="petName" class="profile-form-item">
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.petName"
              placeholder="输入乳名"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="出生地"
          prop="birthAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.birthAddress"
              placeholder="输入出生地"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="常住地"
          prop="placeAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.placeAddress"
              placeholder="输入常住地"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="个人简介"
          prop="introduction"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              type="textarea"
              v-model="userProfileForm.introduction"
              resize="none"
              maxlength="200"
              show-word-limit
              :autosize="{ minRows: 2 }"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="save-profile-btn"
            @click="submitForm('userProfileForm')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="vue-cropper-wrap">
      <el-dialog
        title="更换头像"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        custom-class="handlian-cropper-container"
        width="645px"
      >
        <ImageCropper ref="imageCropper" @cropDone="cropDone" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../utils/apiMap";
import ImageCropper from "../../components/user/image-cropper";
import { getDate } from "../../utils/date";
import qs from "qs";
export default {
  name: "user-data",
  data() {
    return {
      dialogVisible: false,
      userProfileForm: {
        name: "",
        realName: "",
        sex: "",
        birthday: "",
        petName: "",
        birthAddress: "",
        placeAddress: "",
        introduction: "",
        headImgUrl: "",
        thumbHeadImg: "",
      },
      certified: false, //是否已经实名认证
      rules: {
        name: [
          { required: true, message: "请输入网名", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 2 到 12 个字符",
            trigger: "blur",
          },
        ],
        realName: [
          { required: false, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        sex: [{ required: false, message: "请填写性别", trigger: "change" }],
        birthday: [
          { required: false, message: "请填写生日", trigger: "change" },
        ],
        petName: [
          { required: false, message: "请输入乳名", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        birthAddress: [
          { required: false, message: "请输入出生地", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
        placeAddress: [
          { required: false, message: "请输入常住地", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
        introduction: [
          { required: false, message: "请输入个人简介", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    ImageCropper,
  },
  computed: {
    ...mapGetters(["userProfile"]),
    defaultSrc: function() {
      return "http://148.70.221.198/pc/image/cl_user_avatar.png";
    },
  },
  mounted() {
    this.getUserProfile();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
          if (this.userProfile.isValiated == 1) {
            //已经实名认证
            var filedArray = [
              "birthAddress",
              "headImgUrl",
              "introduction",
              "name",
              "petName",
              "placeAddress",
              "thumbHeadImg",
            ];
            var submitArry = [];
            submitArry.push(`token=${loginUser.token}`);
            for (let index = 0; index < filedArray.length; index++) {
              const element = filedArray[index];
              var filedValue = this.userProfileForm[element];
              if (filedValue) {
                submitArry.push(`${element}=${filedValue}`);
              }
            }
            this.modifyUserProfile(submitArry);
          } else {
            if (this.userProfileForm.birthday != "") {
              try {
                this.userProfileForm.birthday = getDate(
                  this.userProfileForm.birthday
                );
              } catch (error) {}
            }
            var filedArray = [
              "birthAddress",
              "birthday",
              "headImgUrl",
              "introduction",
              "name",
              "petName",
              "placeAddress",
              "realName",
              "sex",
              "thumbHeadImg",
            ];
            var submitData = [];
            submitData.push(`token=${loginUser.token}`);
            for (let index = 0; index < filedArray.length; index++) {
              const element = filedArray[index];
              var filedValue = this.userProfileForm[element];
              if (filedValue) {
                submitData.push(`${element}=${filedValue}`);
              }
            }
            this.modifyUserProfile(submitData);
          }
        } else {
          return false;
        }
      });
    },
    modifyUserProfile(params) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["editProfile"]["method"],
          url: apiMap["editProfile"]["url"],
          data: params.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var imProfile = {
              nickName: _this.userProfileForm["name"],
            };
            if (_this.userProfileForm["thumbHeadImg"] != null) {
              imProfile.avatar = _this.userProfileForm["thumbHeadImg"];
            }
            _this.updateProfileToIM(imProfile);
            _this.$message({
              message: "保存成功",
              type: "success",
            });
            _this.$bus.$emit("update-user-profile");
          } else {
            _this.$message({
              message: "保存失败，稍后再试",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getUserProfile() {
      if (JSON.stringify(this.userProfile) != "{}") {
        this.initUserProfile(this.userProfile);
      } else {
        let _this = this;
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["getProfile"]["method"],
            url: apiMap["getProfile"]["url"],
            data: `token=${loginUser.token}`,
          })
          .then(function(response) {
            if (response && response.data.result.statusCode == 1) {
              _this.initUserProfile(response.data.result.data);
              Store.dispatch("setUserProfile", response.data.result.data);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    initUserProfile(proInfo) {
      if (proInfo.isValiated == 1) {
        this.certified = true;
      } else {
        this.certified = false;
      }
      this.userProfileForm = {
        name: this.getTrueValue(proInfo.name),
        realName: this.getTrueValue(proInfo.realName),
        sex: proInfo.sex == "男" ? 1 : 2,
        birthday: this.initUserBirthday(),
        petName: this.getTrueValue(proInfo.petName),
        birthAddress: this.getTrueValue(proInfo.birthAddress),
        placeAddress: this.getTrueValue(proInfo.placeAddress),
        introduction: this.getTrueValue(proInfo.introduction),
        headImgUrl: proInfo.headImgUrl,
        thumbHeadImg: proInfo.thumbHeadImg,
      };
    },
    getTrueValue(originVal) {
      if (originVal && originVal != "null") {
        return originVal;
      }
      return "";
    },
    initUserBirthday() {
      if (this.userProfile.birthday) {
        return new Date(this.userProfile.birthday * 1000);
      }
    },
    initUserAvatar() {
      if (this.userProfile.thumbHeadImg) {
        return this.userProfile.thumbHeadImg;
      } else if (this.userProfile.headImgUrl) {
        return this.userProfile.thumbHeadImg;
      } else {
        return "http://148.70.221.198/pc/image/cl_user_avatar.png";
      }
    },
    modifyAvatar() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs.imageCropper.resetCropper();
      this.dialogVisible = false;
    },
    cropDone(status, url) {
      this.dialogVisible = false;
      //状态1为头像上传成功
      if (status == 1) {
        this.userProfileForm.headImgUrl = url;
        this.userProfileForm.thumbHeadImg = url;
      }
    },
    updateProfileToIM(imProfile) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        From_Account: loginUser.userId.toString(),
        ProfileItem: [
          {
            Tag: "Tag_Profile_IM_Nick",
            Value: imProfile.nickName,
          },
        ],
      };
      if (imProfile.hasOwnProperty("avatar")) {
        params.ProfileItem.push({
          Tag: "Tag_Profile_IM_Image",
          Value: imProfile.avatar,
        });
      }
      var queryData = {
        token: loginUser.token,
        api: "profileSet",
        data: JSON.stringify(params, null, 2),
      };
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["tencentIm"]["method"],
          url: apiMap["tencentIm"]["url"],
          data: qs.stringify(queryData, { encode: false }),
        })
        .then(function(response) {
          // if (response.data.result.ActionStatus == "OK") {
          //   console.log("im资料更新 成功！");
          // } else {
          //   console.log("im资料更新 失败！");
          // }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.profile-tab-container {
  padding: 13px 0;
  background-color: #fff;
}

.user-profile-form {
  position: relative;
}

.profile-form-item {
  position: relative;
}

.certified {
  position: absolute;
  left: 390px;
  top: 9px;
  display: inline-block;
  width: 54px;
  height: 20px;
  line-height: 20px;
  color: #00cc00;
  text-align: center;
  border: 1px solid #00cc00;
  border-radius: 3px;
}

.head-image-wrap {
  position: absolute;
  top: 0;
  right: 120px;
  z-index: 6;
}

.user-profile-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.image-slot {
  width: 100%;
  height: 100%;
}

.image-slot img {
  width: 100%;
  height: 100%;
}

.modify-avatar-wrap {
  text-align: center;
}

.profile-item-content {
  width: 383px;
}

.profile-date-select {
  width: 100%;
}

.modify-avatar-btn {
  padding: 7px 10px;
}

.save-profile-btn {
  padding: 6px 10px;
}
</style>
